import { IconProps } from "@/types/common";
import React from "react";

const UserIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 6.25C8 4.92392 8.52678 3.65215 9.46447 2.71447C10.4021 1.77678 11.6739 1.25 13 1.25C14.3261 1.25 15.5979 1.77678 16.5355 2.71447C17.4732 3.65215 18 4.92392 18 6.25C18 7.57608 17.4732 8.84785 16.5355 9.78553C15.5979 10.7232 14.3261 11.25 13 11.25C11.6739 11.25 10.4021 10.7232 9.46447 9.78553C8.52678 8.84785 8 7.57608 8 6.25ZM8 13.75C6.3424 13.75 4.75269 14.4085 3.58058 15.5806C2.40848 16.7527 1.75 18.3424 1.75 20C1.75 20.9946 2.14509 21.9484 2.84835 22.6517C3.55161 23.3549 4.50544 23.75 5.5 23.75H20.5C21.4946 23.75 22.4484 23.3549 23.1517 22.6517C23.8549 21.9484 24.25 20.9946 24.25 20C24.25 18.3424 23.5915 16.7527 22.4194 15.5806C21.2473 14.4085 19.6576 13.75 18 13.75H8Z"
      />
    </svg>
  );
};

export default UserIcon;
